var _path, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Clock502(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3dd9eb",
    d: "M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 15,
    x: 22,
    y: 11,
    fill: "#5e00f0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 4,
    x: 22,
    y: 22,
    fill: "#5e00f0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 22,
    y: 22,
    fill: "#2100c4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Clock502);
export default __webpack_public_path__ + "static/media/icons8-clock-50-2.ade3740e9214a2cbcedf684ece8b2eda.svg";
export { ForwardRef as ReactComponent };